// DS: MO3.2
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiData, UserNameClickBiEvent } from '@wix/da-bi/pkg/events';
import { ResourceType } from '@wix/da-shared-react/pkg/types/resource';

import s from './ArtAttribution.scss';

interface Props {
  author: {
    username: string;
    usericon: string;
    userId: number;
  };
}

const ArtAttribution: React.FC<Props> = ({ author }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  if (isMobile) {
    return (
      <div className={s['simple-attribution']}>
        {t('shopPage.header.artBy')}{' '}
        <BiLink
          className={s['simple-attribution-userlink']}
          href={Url.userLink(author.username, 'shop')}
          target="_blank"
          rel="noopener noreferrer"
          biData={BiData<UserNameClickBiEvent>({
            evid: 101,
            typeid: ResourceType.USER,
            itemid: author.userId,
          })}
        >
          {author.username}
        </BiLink>
      </div>
    );
  }

  return (
    <BiLink
      className={s['attribution']}
      href={Url.userLink(author.username, 'shop')}
      target="_blank"
      rel="noopener noreferrer"
      biData={BiData<UserNameClickBiEvent>({
        evid: 101,
        typeid: ResourceType.USER,
        itemid: author.userId,
      })}
    >
      {author.usericon && (
        <img
          src={author.usericon}
          className={s['attribution-avatar']}
          alt={author.username}
        />
      )}
      <div className={s['attribution-label']}>
        {t('shopPage.header.artBy')}
        <div className={s['attribution-username']}>{author.username}</div>
      </div>
    </BiLink>
  );
};
ArtAttribution.displayName = 'ArtAttribution';

export default ArtAttribution;
